import { createI18n } from 'vue-i18n';
import en_CA from './en-CA.json';
import fr_CA from './fr-CA.json';

const locale = document.documentElement.getAttribute('lang');
if (!locale) {
  throw new Error('No \'lang\' attribute found on <html> node.');
}

const i18n = createI18n({
  legacy: false,
  locale: locale || 'fr-CA',
  messages: {
    'en-CA': en_CA,
    'fr-CA': fr_CA
  }
});

export default i18n;